import styled from 'styled-components';
import { CommonTable } from '../../../../CommonComponents/commonStyles';

export const BalanceTable = styled(CommonTable)`
    margin-bottom: 0px;
    .ant-table-fixed-header .ant-table-scroll .ant-table-header {
        overflow-x: visible !important;
    }
    .ant-table-body tr td {
        vertical-align: top;
    }
    .ant-table-thead tr th {
        text-align: right;
    }
    .ant-table-thead tr th:nth-child(1), .ant-table-thead tr th:nth-child(2) {
        text-align: left;
    }
    
`

export const ColumnHeader = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    line-height: 1.29;
    color: ${props => props.theme.fontColors.headingColor};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
    }
`

export const CustomDiv = styled.div`
    ${props => props.paddingRight ? "padding-right: 10px" : ""}
    ${props => props.paddingLeft ? "padding-left: 11px" : ""}
    ${props => props.receivedDate ? "padding-left: 3px" : ""}
    ${props => props.customLeft && `padding-left : ${props.customLeft}px`}
`
export const ImgRec = styled.div`
    padding-right: 15px;
`
export const ColumnValueFirst = styled.div`
    padding-bottom: ${props => props.paddingBottom};
    padding-left: ${props => props.paddingLeft};
    @media only screen and (min-width: 852px) and (max-width: 1056px) {
       height: 50px; 
    }
    
`

export const ColumnValues = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    line-height: 1.13;
    color: ${props => props.theme.fontColors.textColor};
    padding-left: ${props => props.paddingLeft};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
    }
`
export const ColumnValuesBegEnd = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    line-height: 1.13;
    color: ${props => props.theme.fontColors.textColor};
    padding-left: ${props => props.paddingLeft};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
    }
`
export const ColumnValuesMrgn = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.tableFont};
    line-height: 1.13;
    margin: 4px 0px 10px 0px;
    &:last-child {
        margin-bottom: 0px;
    }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
    }
`
export const BalanceDiv = styled.div`
    display: flex;
    margin-top: 15px;
`
export const Bsd = styled.div`
    width:50%;
    &:nth-child(2) {
        text-align: right;
    }

`
 
export const BalDataVal = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: ${props => props.theme.letterSpacing.zero};;
  color: ${props => props.theme.fontColors.headingColor};
  //margin-top: 0.375rem;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    }
`
export const BalDataValDesk = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: ${props => props.theme.letterSpacing.zero};;
  color: ${props => props.theme.fontColors.headingColor};
  //margin-top: 0.375rem;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    }
`
export const AccountTableContainer = styled.div`   
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding: 0px 20px;
    }
`;

export const PriceUnit = styled.div`
    width: 100px;
    @media only screen and (min-width: 992px) and (max-width: 1025px) {
        width: 85px;
    }
`;
export const BreakWord = styled.div`
word-break: break-word;
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    word-break: break-all;
  }
`;
export const PoolTitleDesc = styled.span`
margin-top: 15px;
display: inline-block;
`;


export const AmountDescGrid = styled.div`
border-top: 1px solid ${props => props.theme.colors.border};
border-bottom: 1px solid ${props => props.theme.colors.border};
padding-bottom: 15px;
margin-top: 15px;
`;

export const UnitDescGrid = styled.div`
border-bottom: 1px solid ${props => props.theme.colors.border};
padding-bottom: 15px;
margin-top: 15px;
`;

export const ColumnWrapDiv = styled.div`
 text-align: right !important;
 color: red;
`